
























































































	import { BaseTLTableComponent, AxiosResponse, Component, TrainingService, TrainingFilter, Prop, tlISODateToLocalString, tlISODateToLocalStringForm } from "../../../Infrastructure/CorBase/CoreBase";

	@Component
	export default class TrainingsList extends BaseTLTableComponent {

		selectedTrainingId: number = 0;
		TrainingService: TrainingService = new TrainingService();
		
		idPerson: number = 0;
		idTypeTraining = '';

		labelWidth: string = "1";
		inputWidth: string = "6";
		updateMode = false;

		formData = {
			id: 0,
			idPerson: 0,
			idTrainingType: 0,
			validFrom: '',
			validTo: '',
		};

		@Prop({ type: Boolean, required: false, default: false }) isUpdate?: boolean;

		setFields() {
			this.fields = [
				//{ key: 'id', label: 'id', sortable: true, class: 'text-center' },
				{ key: 'idTrainingTypeNavigationName', label: 'Druh', sortable: true, class: 'text-center' },
				{ key: 'validFrom', label: 'Počátek platnosti', sortable: true, class: 'text-center' },
				{ key: 'validTo', label: 'Konec platnosti', sortable: true, class: 'text-center' },
				{ key: 'actions', label: 'Volby' }
			]
		};

		//filtry
		setfilters(value: any) {
		}

		allowField() {
			return this.updateMode || this.formData.idTrainingType > 0;
		}

		setPersonId(id: number) {
			this.idPerson = id;
			this.fetchData();
		}

		prepareItems(items: any[]) {
			for (var i = 0; i < items.length; i++) {
				items[i].validFrom = tlISODateToLocalString(items[i].validFrom);
				items[i].validTo = tlISODateToLocalString(items[i].validTo);
			}
		}

		created() {
			super.initializeRights('COR_Person_Create', 'COR_Person_Delete', 'COR_Person_Read', 'COR_Person_Update');
			super.created();
			this.idPerson = this.objectIdFromParam;
			this.fetchData();
		};

		goBack() {
			this.updateMode = false;
			this.formData.idTrainingType = -1;
			this.formData.validFrom = '';
			this.formData.validTo = '';
		}

		startUpdate(id: any) {
			var item = this.tableData.filter(c => c.id == id)[0];
			this.formData.id = id;
			this.formData.idPerson = this.idPerson;
			this.formData.idTrainingType = item.idTrainingType;
			this.formData.validFrom = tlISODateToLocalStringForm(new Date(item.validFrom));
			this.formData.validTo = tlISODateToLocalStringForm(item.validTo);
			this.updateMode = true;
		}
		
		update() {			
			this.TrainingService.update(this.formData.id, this.formData).then(() => {
				this.goBack();
				this.fetchData();
			})
		}

		fetchData() {
			if (this.idPerson > 0) {
				super.fetchData();
			}
		}

		createNewClick() {
			this.formData.id = 0;
			this.formData.idPerson = this.idPerson;
			this.TrainingService.create(this.formData).then(() => {
				this.goBack();
				this.fetchData();
			});
	}

		deleteClick(elementId: any) {
			this.TrainingService.delete(elementId).then(() => {
				this.goBack();
				this.fetchData();
			});		
		}

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let trainingFilter: TrainingFilter = new TrainingFilter(this.idPerson);
			return this.TrainingService.getAllByFilter(trainingFilter);
		}

        //zatím nepotrebujeme
        fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
            return this.fetchDataFromServer();
        }

        refreshItems(items: any[], refreshData: any[]) {
            return items;
        }

		vBeginning: boolean = true;
		vEnd: boolean = true;		

		isCorrectBeginning(value: any) {
			this.vBeginning = value;
		}

		isCorrectEnd(value: any) {
			this.vEnd = value;
		}

		validate() {
			return !(this.vBeginning &&  this.vEnd );
		}


	};
